/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-18 17:24:08
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:53:25
 * @FilePath: \unified-development-platform\src\apis\auth\move-auth\role_manage_api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { request } from '@/apis/request'
const PRE_PATH = '/v1/sys'
export const get_role_list = (params) => {
  return request({
    url: `${PRE_PATH}/sysRole/list`,
    method: 'get', params: params,
    rd: true
  })

}
export const delete_role = (roleNo) => {
  return request({
    url: `${PRE_PATH}/sysRole/delete?no=${roleNo}`,
    method: 'get',
    rd: true
  })
}
export const get_related_users = (params) => {
  return request({
    url: `${PRE_PATH}/sysUser/queryByRole`,
    method: 'get', params: params,rd: true
  })
}
export const  relate_users = (params) =>  {
  return request({
    url: `${PRE_PATH}/sysRole/assignRole`,
    method: 'post',
    data: params,rd: true
  })
}
export const update_role = (params) => {
  return request({
    url: `${PRE_PATH}/sysRole/save`,
    method: 'post',
    data: params,rd: true
  })
}
export const get_role_detail = (roleNo) => {
  return request({
    url: `${PRE_PATH}/sysRole/queryById?no=${roleNo}`,
    method: 'get',rd: true
  })
}
export const get_enable_roles = (params) => {
  return request({
    url: `${PRE_PATH}/sysRole/all`,
    method: 'get', params: params,rd: true
  })
}
export const check_role_name = (roleNo, roleName) => {
  return `${PRE_PATH}/sysRole/roleName?roleNo=${roleNo}&roleName=${roleName}`
}

export const get_role_menus_buttons = (rolePlatformNo) => {
  return request({
    url: `${PRE_PATH}/menu/roleMenuAndButtons?rolePlatformNo=${rolePlatformNo}`,
    method: 'get',rd: true
  })
}